module.exports = __webpack_public_path__ + "img/logo.30c2c083.png";